import * as Sentry from '@sentry/vue'
// @ts-ignore
import { isAxiosError, type AxiosResponse } from 'axios'

class ApiError extends Error {
  constructor(name: string, ...params: string[]) {
    super(...params)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError)
    }

    this.name = name
    this.stack = new Error().stack
  }
}

export const useApiError = (response: AxiosResponse) => {
  const { url } = response.config

  // @ts-ignore
  Sentry.withScope((scope) => {
    const fullURL = `${response.config?.baseURL}${url}`
    const statusCode = (!isAxiosError(response) ? response.status : response.response?.status) || 0
    const data = (!isAxiosError(response) ? response.data : response.response?.data) || null
    const name = `API ERROR [${statusCode}] in [${url}]`
    const message = `URL: ${location.pathname} / API: ${fullURL}`

    if (statusCode === 0) {
      return
    }

    scope.setLevel('error')

    scope.setExtras({
      status: statusCode,
      fullURL,
      params: response.config.params || null,
      request: JSON.stringify(response.config.data || null),
      response: data,
      responseDeep: JSON.stringify(data),
    })

    scope.setTag('api', true)

    const error = new ApiError(name, message)

    // @ts-ignore
    Sentry.captureException(error)
  })
}
